import Topbar from "./components/topbar/Topbar";
import  Intro from "./components/intro/Intro";
import Works  from "./components/works/Works";
import  Contacts  from "./components/contacts/Contacts";
//import  Testimonials  from "./components/testimonials/Testimonials";
import "./app.scss"
import {useState} from "react";
import Menu from "./components/menu/Menu"
function App() {
  const [menueOpen,setMenueOpen] = useState(false)
  const [theme,setTheme] = useState(false)
  return (
   
    <div className="app">
      <Topbar menueOpen={menueOpen} setMenueOpen={setMenueOpen} theme={theme} setTheme={setTheme}/>
      <Menu menueOpen={menueOpen} setMenueOpen={setMenueOpen}   theme={theme} setTheme={setTheme}/>
      <div className="sections">
         <Intro theme={theme} setTheme={setTheme}/>
    
         <Works theme={theme} setTheme={setTheme}/>
       
        <Contacts theme={theme} setTheme={setTheme}/>
      </div>
    </div>
  );
}

export default App;
